import { Component, OnInit, Inject } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { FormValidatorService } from 'src/app/shared/form_Validation/form-validator.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-upload-photo',
  templateUrl: './upload-photo.component.html',
  styleUrls: ['./upload-photo.component.css']
})
export class UploadPhotoComponent implements OnInit {
  imageChangedEvent :any;
  org_file:File;
  croppedImage: string;
  supportedDocType = [];
  image: FormGroup;
  apiImage: any;
  instructionString: string;
  supportedFile={
    maxSize:'',
    fileSize:0,
    type:''
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
     private _api: ApiService
    , public dialogRef: MatDialogRef<any>,
    private formbuilder: FormBuilder
    , private spinner :NgxSpinnerService
    , private Formvalidator: FormValidatorService
    , private _utilityService: UtilitiesService
  ) {
    this.image = this.formbuilder.group({
      file: new FormControl('')
    });
   }

  ngOnInit() {
    this.getSupportedFiles();
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64; 
    let file :any
     file = new File([event['file']], this.org_file.name, {type:this.org_file.type});
    this.apiImage = file;

}
fileChangeEvent(event: any) {
  const file = event.target.files[0];
  this.org_file = file;
    if (file) {
      const extn = file.name.split('.').pop();
      if (this.supportedDocType.includes(extn.toLowerCase())) {
        if (file.size > this.supportedFile['fileSize']) {
          this._api.openSnackBar('Size should be less than '+this.supportedFile['maxSize'], 'Error');
        return false;

        }
      } else {
        this._api.openSnackBar('File not supported', 'Error');
        return false;

      }
    }
  this.imageChangedEvent = event;
 }

closeModel() {
  this.dialogRef.close();
}
uploadImage() {
  if (!this.apiImage) {
    this._api.openSnackBar('Select an Image to upload' , 'Error');
    return;
  } 
  const formdata = new FormData();
  formdata.append('file', this.apiImage);
  this.spinner.show();
  this._api.functionPOST('user/editUserImage' , formdata).subscribe((response) => {
    this.spinner.hide();
    this._api.openSnackBar(response['data'] , 'Success');
  this._utilityService.changeProfilepic(true);
    this.dialogRef.close(true);
  });
}

getSupportedFiles() {
  this._utilityService.supportedDocumentTypemsg.subscribe(res => {
    if (res ) {
      const files   =  res['supported_file_types'];
      this.supportedDocType = files.split(',');
    }
    var size = (res['max_file_size_bytes']/1000000)+' MB';
    this.supportedFile={
      maxSize:size,
      fileSize:res['max_file_size_bytes'],
      type:res['supported_file_types']
    };
     this.instructionString = '* Supported document types are ' +
     this.supportedFile['type'] + '\n' + '* Supported maximum file size is ' + this.supportedFile['maxSize'];
   }
    );
}


}
